import { BrowserRouter, Route, Routes } from "react-router-dom";

import Layout from "@/components/Layout";
import { useSession } from "@/hooks/useSession";
import ApplicationDetail from "@/pages/ApplicationDetail";
import Applications from "@/pages/Applications";
import Audit from "@/pages/Audit";
import Backups from "@/pages/Backups";
import Bans from "@/pages/Bans";
import Certificates from "@/pages/Certificates";
import Events from "@/pages/Events";
import Exceptions from "@/pages/Exceptions";
import Jobs from "@/pages/Jobs";
import Login from "@/pages/Login";
import Ops from "@/pages/Ops";
import Overview from "@/pages/Overview";
import Migration from "@/pages/Migration";
import Modules from "@/pages/Modules";
import Pages from "@/pages/Pages";
import Plugins from "@/pages/Plugins";
import Policies from "@/pages/Policies";
import Settings from "@/pages/Settings";
import Updates from "@/pages/Updates";

function Gate() {
  const { user, loading } = useSession();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) return <Login />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/applications/:id" element={<ApplicationDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/exceptions" element={<Exceptions />} />
        <Route path="/bans" element={<Bans />} />
        <Route path="/ops" element={<Ops />} />
        <Route path="/plugins" element={<Plugins />} />
        <Route path="/modules" element={<Modules />} />
        <Route path="/pages" element={<Pages />} />
        <Route path="/migration" element={<Migration />} />
        <Route path="/updates" element={<Updates />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/backups" element={<Backups />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Overview />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Gate />
    </BrowserRouter>
  );
}
